module.exports = __webpack_public_path__ + "img/story050.0ed69c96.png";